(() => {
  function mount() {
    const root = document.querySelector('[data-activate-page]');
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const form = root.querySelector('[data-activate-form]');
    const quantity = form.elements.quantity;
    const buttons = [...root.querySelectorAll('[data-act-add]')];
    const status = root.querySelector('[data-act-status]');
    const sticky = root.querySelector('[data-act-sticky]');
    const hero = root.querySelector('#act-hero-cta');
    const final = root.querySelector('#act-final-cta');
    const facts = root.querySelector('[data-act-facts]');
    const route = window.Shopify?.routes?.root || '/';
    let busy = false, returnFocus = null, frame = 0;
    const unavailable = buttons.some(button => button.disabled);
    function validQuantity() {
      const min = Number(quantity.min) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const step = Number(quantity.step) || 1;
      let value = Number(quantity.value);
      if (!Number.isFinite(value)) value = min;
      value = Math.max(min, Math.min(max, min + Math.round((value - min) / step) * step));
      quantity.value = String(value);
      root.querySelector('[data-quantity-step="-1"]').disabled = value <= min || busy;
      root.querySelector('[data-quantity-step="1"]').disabled = value >= max || busy;
      return value;
    }
    root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      quantity.value = validQuantity() + Number(button.dataset.quantityStep) * (Number(quantity.step) || 1);
      validQuantity();
    }));
    quantity.addEventListener('change', validQuantity);
    function showCartLink(message) {
      status.replaceChildren(document.createTextNode(message + ' '));
      const link = document.createElement('a');
      link.href = route + 'cart';
      link.textContent = 'View cart';
      status.append(link);
      status.scrollIntoView({block:'nearest',behavior:'auto'});
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || unavailable) return;
      validQuantity();
      if (!form.reportValidity()) return;
      busy = true;
      buttons.forEach(button => {button.disabled = true;button.setAttribute('aria-busy','true');});
      status.textContent = 'Adding ACTIVATE…';
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true,detail:{sections}}));
      const data = new FormData(form);
      data.set('sections',[...new Set(sections)].slice(0,5).join(','));
      data.set('sections_url',location.pathname.startsWith('/') ? location.pathname + location.search : form.dataset.renderUrl);
      quantity.disabled = true;
      validQuantity();
      let added = false;
      try {
        const response = await fetch(route + 'cart/add.js', {method:'POST',body:data,headers:{'X-Requested-With':'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok) {
          status.textContent = typeof result.description === 'string' ? result.description : 'ACTIVATE could not be added. Please check your quantity and try again.';
          return;
        }
        added = true;
        const drawer = document.querySelector('cart-drawer');
        const notification = document.querySelector('cart-notification-drawer');
        const cartType = window.themeVariables?.settings?.cartType;
        if (cartType === 'page' || (!drawer && !notification)) {location.assign(route + 'cart');return;}
        const cartResponse = await fetch(route + 'cart.js', {headers:{'Accept':'application/json'}});
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        const expectedSection = drawer?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-','');
        if (drawer && (!expectedSection || !cart.sections?.[expectedSection])) throw new Error('Cart section unavailable');
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items || [result],cart}}));
        status.textContent = 'ACTIVATE added to your cart.';
        queueSticky();
      } catch (error) {
        if (added) showCartLink('ACTIVATE was added. Open your cart to continue.');
        else showCartLink('We could not confirm the cart update. Check your cart before trying again.');
      } finally {
        busy = false;
        quantity.disabled = false;
        buttons.forEach(button => {button.disabled = unavailable;button.removeAttribute('aria-busy');});
        validQuantity();
      }
    });
    root.querySelectorAll('[data-facts-open]').forEach(button => button.addEventListener('click', () => {
      returnFocus = button;
      facts.showModal();
      queueSticky();
    }));
    root.querySelector('[data-facts-close]').addEventListener('click', () => facts.close());
    facts.addEventListener('close', () => {returnFocus?.focus({preventScroll:true});queueSticky();});
    facts.addEventListener('click', event => {if (event.target === facts) {const b = facts.getBoundingClientRect();if(event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) facts.close();}});
    root.querySelectorAll('a[href^="#activate-"]').forEach(link => link.addEventListener('click', event => {
      const target = document.querySelector(link.hash);
      if (!target) return;
      event.preventDefault();
      history.pushState(null,'',link.hash);
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    }));
    function updateSticky() {
      frame = 0;
      const heroBox = hero.getBoundingClientRect();
      const finalBox = final.getBoundingClientRect();
      const visibleFinal = finalBox.top < innerHeight && finalBox.bottom > 0;
      const visibleOverlay = [...document.querySelectorAll('dialog[open],cart-drawer[open],cart-notification-drawer[open],privacy-bar[open],#shopify-pc__banner,[role="dialog"][aria-modal="true"]')].some(node => {
        const box = node.getBoundingClientRect();return box.width > 0 && box.height > 0 && getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none';
      });
      sticky.hidden = !matchMedia('(max-width:699px)').matches || heroBox.bottom > 0 || visibleFinal || visibleOverlay || root.querySelector('.act-footer').getBoundingClientRect().top < innerHeight;
    }
    function queueSticky() {if (!frame) frame = requestAnimationFrame(updateSticky);}
    new IntersectionObserver(queueSticky,{threshold:[0,1]}).observe(hero);
    new IntersectionObserver(queueSticky,{threshold:[0,1]}).observe(final);
    const overlayObserver = new MutationObserver(queueSticky);
    overlayObserver.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','aria-hidden'],childList:true});
    addEventListener('scroll',queueSticky,{passive:true});
    addEventListener('resize',queueSticky,{passive:true});
    addEventListener('pageshow',() => {busy=false;quantity.disabled=false;buttons.forEach(button => {button.disabled=unavailable;button.removeAttribute('aria-busy');});validQuantity();queueSticky();});
    validQuantity();queueSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  document.addEventListener('shopify:section:load',mount);
})();
